// extracted by mini-css-extract-plugin
export default {"container":"KX-z","title":"LX-z","link":"MX-z"};